module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('partial-loader', {
    attrs: {
      "loading": _vm.isFetching
    }
  })], 1), _vm._v(" "), (!_vm.isFetching) ? _c('div', {
    staticClass: "col-12"
  }, [(_vm.formError.errors) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, _vm._l((_vm.formError.errors), function(errors) {
    return _c('span', _vm._l((errors), function(error) {
      return _c('span', [_vm._v(_vm._s(error)), _c('br')])
    }), 0)
  }), 0) : _vm._e(), _vm._v(" "), _c('b-jumbotron', {
    staticClass: "mb-3 p-4"
  }, [_c('h1', {
    staticClass: "display-4"
  }, [_vm._v(_vm._s(_vm.$t('item.setAuctionOrderNumbersTitle')))]), _vm._v(" "), _c('b-form', {
    staticClass: "mb-3",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.setAuctionOrderNumber($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('autocomplete-category', {
    attrs: {
      "label": _vm.$t('item.category')
    },
    on: {
      "update:category": _vm.updateCategoryId
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('item.startNumber')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "step": "1",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.start_number),
      callback: function($$v) {
        _vm.$set(_vm.form, "start_number", $$v)
      },
      expression: "form.start_number"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary",
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-ol",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('item.setAuctionOrderNumbers')) + "\n\t\t\t\t\t\t\t")])], 1)])])], 1)], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a051e37e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Auction/Item/ItemOrder.vue
// module id = 1333
// module chunks = 1